import { updateOneVersion } from 'serviceWorker/db/documentations/documentations';
import { SyncStatus } from 'shared/domain/entitySyncStatus/syncStatus';

export type SetVersionSync = (localId: number, versionId: string, syncStatus: SyncStatus) => Promise<number>;

/** The sync state of one version; the documentation's other versions stay as they are. */
export const setVersionSync: SetVersionSync = (localId, versionId, syncStatus) =>
  updateOneVersion(localId, versionId, { syncStatus });
